import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Crosshair, Clock, CheckCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const calibrationStatuses = ["adas_analysis", "approved", "in_calibration", "completed"];

export default function Calibration() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data.filter((j) => calibrationStatuses.includes(j.status))));
  }, []);

  const cols = calibrationStatuses.map((s) => ({
    status: s,
    label: s.replace("_", " ").toUpperCase(),
    items: jobs.filter((j) => j.status === s),
  }));

  return (
    <div className="space-y-6 animate-slide-up" data-testid="calibration-page">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold mb-2">Operations</div>
        <h1 className="font-display text-4xl font-semibold tracking-tight">Calibration Center</h1>
        <p className="text-sm text-slate-400 mt-1.5">Kanban view of all jobs flowing through the calibration workflow.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {cols.map((col) => (
          <div key={col.status} className="rounded-xl border border-slate-800 bg-[#0B1120] p-4 min-h-[400px]" data-testid={`column-${col.status}`}>
            <div className="flex items-center justify-between mb-4 pb-3 border-b border-slate-800">
              <div className="flex items-center gap-2">
                {col.status === "completed" ? <CheckCircle className="w-4 h-4 text-emerald-400" /> : col.status === "in_calibration" ? <Crosshair className="w-4 h-4 text-blue-400" /> : <Clock className="w-4 h-4 text-amber-400" />}
                <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-300">{col.label}</div>
              </div>
              <Badge className="bg-slate-800 text-slate-300 border-slate-700">{col.items.length}</Badge>
            </div>
            <div className="space-y-2">
              {col.items.map((j) => (
                <Link key={j.id} to={`/jobs/${j.id}`} className="block p-3 rounded-lg bg-slate-900/40 border border-slate-800/50 hover:border-blue-500/40 transition-colors">
                  <div className="font-mono text-xs text-blue-300 mb-1">{j.vin.slice(-8)}</div>
                  <div className="text-sm font-medium">{j.vehicle_year} {j.vehicle_make}</div>
                  <div className="text-xs text-slate-500 mt-1">{j.customer_name}</div>
                  <div className="text-xs text-cyan-400 font-mono mt-2">${(j.adas_analysis?.total_calibration_fees || 0).toFixed(0)}</div>
                </Link>
              ))}
              {col.items.length === 0 && <div className="text-xs text-slate-600 text-center py-8">Empty</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
